import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import ConfirmDialog from '@/components/base/ConfirmDialog';
import { useToast } from './ToastProvider';
import { useAuth } from '@/contexts/AuthContext';
import { getPageMeta } from '@/lib/navigation';

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [signingOut, setSigningOut] = useState(false);

  const { signOut } = useAuth();
  const { notify } = useToast();
  const location = useLocation();
  const meta = getPageMeta(location.pathname);

  const handleConfirmLogout = async () => {
    setSigningOut(true);
    await signOut();
    setSigningOut(false);
    setConfirmOpen(false);
    notify({ tone: 'info', title: 'Sesión cerrada', message: 'Ha salido del sistema correctamente.' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onLogoutRequest={() => setConfirmOpen(true)}
      />

      <div className="flex min-h-screen flex-col lg:pl-64">
        <Header
          meta={meta}
          onMenuClick={() => setSidebarOpen(true)}
        />

        <main className="flex-1 px-4 py-6 md:px-7 md:py-8">
          <div className="mx-auto w-full max-w-[1400px]">
            <Outlet />
          </div>
        </main>
      </div>

      <ConfirmDialog
        open={confirmOpen}
        title="¿Está seguro de que desea cerrar sesión?"
        description="Se cerrará su sesión actual y volverá a la pantalla de inicio de sesión."
        confirmLabel="Cerrar sesión"
        cancelLabel="Cancelar"
        tone="warning"
        icon="ri-logout-box-r-line"
        loading={signingOut}
        onConfirm={handleConfirmLogout}
        onCancel={() => setConfirmOpen(false)}
      />
    </div>
  );
}